import { Icon, Tooltip } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';
import { AiFillQuestionCircle } from 'react-icons/ai';

export interface IIconTooltipProps {
  text?: string | ReactNode;
  hasArrow?: boolean;
}

export const IconTooltip: FC<IIconTooltipProps> = ({ text = '', hasArrow = true }) => {
  return (
    <Tooltip label={text} hasArrow={hasArrow} shouldWrapChildren>
      <Icon as={AiFillQuestionCircle} boxSize="5" color="accent" />
    </Tooltip>
  );
};

export default IconTooltip;
